import React from "react";
import { styled } from "@mui/material/styles";
import {
  Typography,
  Paper,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from "@mui/material";
import EpayForm from "./epay_form";

const BRAND = "#f05d32";

const RadioBtn = styled(Radio)(() => ({
  color: BRAND,
  "&.Mui-checked": {
    color: BRAND,
    "&:hover": {
      background: "transparent",
    },
  },
  "&:hover": {
    background: "transparent",
  },
}));

export default function Checkout(props) {
  const { component } = props;
  const devHelper = component.getHelpers("dev");

  const { order = null } = component.getData("default", {});

  const paymentTypes = component.getData(
    "default.order.spot.payment_types",
    [],
  );

  const icons = {
    cash: "fa-solid fa-wallet",
    "epay-credit": "fa-regular fa-credit-card",
  };

  const selectedId = component.findPaymentTypeSelected();

  return (
    <>
      {order && (
        <Paper
          elevation={0}
          sx={{
            px: { xs: 2, md: 2.5 },
            py: { xs: 2, md: 2.5 },
            borderRadius: "16px",
            backgroundColor: "#fff",
            border: "1px solid rgba(0,0,0,0.06)",
            boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: 18, sm: 20, md: 22 },
              lineHeight: 1.2,
              mb: 2,
              color: "#1a1a1a",
            }}
          >
            {component.ucfirst("checkout-title-3")}
          </Typography>
          <RadioGroup
            name="payment_method"
            value={selectedId}
            sx={{ gap: 1 }}
          >
            {paymentTypes
              .filter((paymentType) => paymentType.active)
              .map((paymentType) => {
                const { item } = paymentType;
                const { _values } = item;
                const slug = devHelper.getObjectValue(_values, "slug");
                const id = devHelper.getObjectValue(item, "_id");
                const isSelected = selectedId === id;

                return (
                  <FormControlLabel
                    key={slug}
                    value={id}
                    control={<RadioBtn disableRipple />}
                    onClick={() => component.updatePaymentType(id)}
                    sx={{
                      m: 0,
                      px: 1.5,
                      py: 1,
                      borderRadius: "12px",
                      border: isSelected
                        ? `1.5px solid ${BRAND}`
                        : "1px solid rgba(0,0,0,0.08)",
                      bgcolor: isSelected
                        ? "rgba(240, 93, 50, 0.06)"
                        : "#fafafa",
                      transition:
                        "border-color 0.2s ease, background 0.2s ease",
                      "&:hover": {
                        borderColor: "rgba(240, 93, 50, 0.4)",
                      },
                    }}
                    label={
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          fontSize: 15,
                          fontWeight: 600,
                          color: "#1a1a1a",
                          pl: 0.5,
                        }}
                      >
                        {component.ucfirst(
                          devHelper.getObjectValue(_values, "slug"),
                        )}
                        <Box
                          sx={{
                            width: 34,
                            height: 34,
                            borderRadius: "50%",
                            bgcolor: isSelected
                              ? "rgba(240, 93, 50, 0.12)"
                              : "rgba(0,0,0,0.05)",
                            color: isSelected ? BRAND : "#6b6b65",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 15,
                          }}
                        >
                          <i className={icons[slug] || icons.cash} />
                        </Box>
                      </Box>
                    }
                  />
                );
              })}
          </RadioGroup>
        </Paper>
      )}
      <EpayForm {...props} />
    </>
  );
}
